import { createContext, useContext, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const VALID_LANGUAGES = ['es', 'en', 'de'];
const DEFAULT_LANGUAGE = 'en';

export const LanguageProvider = ({ children }) => {
  const params = useParams();
  const navigate = useNavigate();
  const urlLanguage = params.lang || DEFAULT_LANGUAGE;
  
  // Validar que el idioma de la URL sea válido
  const validLanguage = VALID_LANGUAGES.includes(urlLanguage) ? urlLanguage : DEFAULT_LANGUAGE;
  
  const [language, setLanguage] = useState(validLanguage);

  // Redirigir si el idioma de la URL no es válido
  useEffect(() => {
    if (urlLanguage && !VALID_LANGUAGES.includes(urlLanguage)) {
      navigate(`/${DEFAULT_LANGUAGE}`, { replace: true });
    }
  }, [urlLanguage, navigate]);

  // Sincronizar el idioma con la URL cuando cambie el parámetro
  useEffect(() => {
    if (validLanguage !== language) {
      setLanguage(validLanguage);
    }
  }, [validLanguage, language]);

  const changeLanguage = (newLanguage) => {
    if (VALID_LANGUAGES.includes(newLanguage)) {
      setLanguage(newLanguage);
      // Actualizar la URL sin recargar la página
      navigate(`/${newLanguage}`, { replace: true });
    }
  };

  const value = {
    language,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 